import React, { useContext } from 'react';
import { TranslationContext } from './Context';

const Sample = () => {
  return (
    <>
      <div>
        <Test />
      </div>
      <Test1 />
    </>
  );
};

const Test = () => {
  const context = useContext(TranslationContext);
  return <button>{context.t('common:save')}</button>;
};

const Test1 = () => {
  return (
    <TranslationContext.Consumer>
      {(context: any) => <h1>{context.t('title')}</h1>}
    </TranslationContext.Consumer>
  );
};

export default Sample;
